import { gbp, pct } from "../lib/format";
import { VatNote } from "./common";

const cell = "px-3 py-2.5 text-right font-figure whitespace-nowrap";

export function YearQuarters({ ys }) {
  return (
    <div className="overflow-x-auto grid-scroll">
      <table className="dt w-full text-sm" data-testid="year-summary-table">
        <thead>
          <tr className="border-b text-xs text-muted-foreground">
            <th className="px-3 py-2 text-left font-semibold">Quarter</th>
            <th className="px-3 py-2 text-right font-semibold">Equity requirement<span className="hidden md:inline"> (equity put in)</span></th>
            <th className="px-3 py-2 text-right font-semibold">Cash in<span className="hidden md:inline"> (equity + profit received)</span></th>
            <th className="px-3 py-2 text-right font-semibold">Net</th>
            <th className="px-3 py-2 text-right font-semibold">Running total</th>
            <th className="px-3 py-2 text-right font-semibold">Family Office profit</th>
          </tr>
        </thead>
        <tbody>
          {ys.quarters.map((q) => (
            <tr key={q.quarter} className="border-b last:border-0" data-testid={`ys-row-${q.quarter.replace(" ", "-").toLowerCase()}`}>
              <td className="px-3 py-2.5 font-semibold whitespace-nowrap">
                {q.quarter} <span className={`ml-1 text-[10px] uppercase tracking-wider ${q.status === "Forecast" ? "text-[hsl(var(--warning))]" : "text-muted-foreground"}`}>{q.status}</span>
              </td>
              <td className={cell}>{gbp(q.out)}</td>
              <td className={cell}>{gbp(q.in)}</td>
              <td className={`${cell} ${q.net < 0 ? "text-primary" : "text-[hsl(var(--positive))]"}`}>{gbp(q.net)}</td>
              <td className={cell}>{gbp(q.running)}</td>
              <td className={cell}>{gbp(q.fo_profit)}</td>
            </tr>
          ))}
          <tr className="bg-muted/60 font-bold" data-testid="ys-total-row">
            <td className="px-3 py-3 font-heading">Year total</td>
            <td className={cell} data-testid="ys-total-out">{gbp(ys.totals.out)}</td>
            <td className={cell} data-testid="ys-total-in">{gbp(ys.totals.in)}</td>
            <td className={`${cell} ${ys.totals.net < 0 ? "text-primary" : ""}`} data-testid="ys-total-net">{gbp(ys.totals.net)}</td>
            <td className={cell}></td>
            <td className={cell} data-testid="ys-total-fo">{gbp(ys.totals.fo_profit)}</td>
          </tr>
        </tbody>
      </table>
      <VatNote testid="year-summary-vat-note" className="px-3 pt-2" />
    </div>
  );
}

export function WhoGetsWhat({ ys }) {
  const strong = ["afzal_total", "all"];
  return (
    <div className="overflow-x-auto grid-scroll">
      <table className="dt w-full text-sm" data-testid="who-gets-what-table">
        <thead>
          <tr className="border-b text-xs text-muted-foreground">
            <th className="px-3 py-2 text-left font-semibold">Who gets what in {ys.year}</th>
            <th className="px-3 py-2 text-right font-semibold">Equity requirement</th>
            <th className="px-3 py-2 text-right font-semibold">Equity returned</th>
            <th className="px-3 py-2 text-right font-semibold">Profit</th>
            <th className="px-3 py-2 text-right font-semibold">Cash in</th>
            <th className="px-3 py-2 text-right font-semibold">Net</th>
          </tr>
        </thead>
        <tbody>
          {ys.who_gets_what.map((w) => (
            <tr key={w.key} className={`border-b last:border-0 ${strong.includes(w.key) ? "bg-muted/60 font-bold" : ""}`} data-testid={`wgw-${w.key}`}>
              <td className="px-3 py-2.5 min-w-[220px]">{w.label}</td>
              <td className={cell}>{gbp(w.out)}</td>
              <td className={cell}>{gbp(w.equity_back)}</td>
              <td className={cell}>{gbp(w.profit)}</td>
              <td className={cell} data-testid={`wgw-${w.key}-cash-in`}>{gbp((w.equity_back || 0) + (w.profit || 0))}</td>
              <td className={`${cell} ${w.net < 0 ? "text-primary" : ""}`}>{gbp(w.net)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-4 text-xs text-muted-foreground" data-testid="split-explainer">
        Shared projects (AM/SM): equity {pct(ys.splits.amsm.equity_afzal, 0)} Afzal / {pct(ys.splits.amsm.equity_shabeer, 0)} Shabeer.
        Profit: Afzal keeps {pct(ys.splits.amsm.profit_afzal_keeps, 2)}, Family Office {pct(ys.splits.amsm.profit_fo, 2)}, Shabeer {pct(ys.splits.amsm.profit_shabeer, 0)}.
        Afzal-only projects: Family Office takes {pct(ys.splits.am.profit_fo, 0)} of profit.
      </p>
    </div>
  );
}
